export default __webpack_public_path__ + "static/media/Jones_04.beed70e1.jpg";